import { useEffect, useState, useMemo, useRef } from "react";

import { useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { PieChart } from "./charts/PieChart/PieChart";
import { Row, Col, FormCheck } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { MCTooltip } from "../../MainComponents/Tooltip/Tooltip";
import { EGButton } from "../../MainComponents/Button/EGButton/EGButton";
import { EGIconButton } from "../../MainComponents/Button/IconButton/IconButton";
import {
  deleteElement,
  updateDataGraphicByPath,
  oneColumnChange,
  modifyOrder
} from "../../../apis/apiDashboard";
import BarChart from "./charts/BarChart/BarChart";
import { GraphicComplements } from "./complements/GraphicComplements";
import "./graphics.scss";


// import { DatePicker } from '@mui/lab';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Box, Button, Popover, TextField } from '@mui/material';
import { format } from 'date-fns';


import Modal from 'react-bootstrap/Modal';
// import { PieChart } from "./charts/PieChart/PieChart";
import { DonutChart } from "./charts/PieChart/DonutChart";
import { DoubleChart } from "./charts/PieChart/DoubleChart";
import { NightingaleChart } from "./charts/PieChart/NightingaleChart";
import { RoseChart } from "./charts/PieChart/RoseChart";
import { LineChart } from "./charts/LineChart/historicLineChart";
import { LineChartSteps } from "./charts/LineChart/LineChartSteps";
import { LineChartWhitOutScales } from "./charts/LineChart/LineChartWithoutScale";
import { MonthsReportsHistoric } from "./charts/LineChart/MonthsReportsHistoric";
import { MonthsReportsHistoricBarChart } from "./charts/LineChart/MonthsReportsHistoricBarChart";
import { LineDoubleOpenClose } from "./charts/SpecialChart/LineDoubleOpenClose";
import { DispersionChart } from "./charts/SpecialChart/GraficaDispersion";
import { BarChartHistoric } from "./charts/LineChart/BarChartHistoric";
import { RadarChart } from "./charts/RadarChart/RadarChart";
import { WorldBubbleChart } from "./charts/GeoChart/WorldBubbleChart";
import { GeoXTypeChart } from "./charts/SpecialChart/GeoXTypeChart";
import { MexicoChart } from "./charts/GeoChart/MexicoGeoChart";
import { ColombiaChart } from "./charts/GeoChart/ColombiaGeoChart";
import { HondurasChart } from "./charts/GeoChart/HondurasGeoChart";
import { ChileChart } from "./charts/GeoChart/ChileGeoChart";
import { ElSalvadorChart } from "./charts/GeoChart/ElSalvadorGeoChart";
import { EcuadorChart } from "./charts/GeoChart/EcuadorGeoChart";
import { GuatemalaChart } from "./charts/GeoChart/GuatemalaGeoChart";
import { PeruChart } from "./charts/GeoChart/PeruGeoChart";
import { NicaraguaChart } from "./charts/GeoChart/NicaraguaGeoChart";
import { PanamaChart } from "./charts/GeoChart/PanamaGeoChart";
import { USAChart } from "./charts/GeoChart/USAGeoChart";
import { CanadaChart } from "./charts/GeoChart/CanadaGeoChart";
import { BrasilChart } from "./charts/GeoChart/BrasilGeoChart";
import { EspanaChart } from "./charts/GeoChart/EspanaGeoChart";
import { ItalyChart } from "./charts/GeoChart/ItalyGeoChart";
import { PortugalChart } from "./charts/GeoChart/PortugalGeoChart";
import { PoloniaChart } from "./charts/GeoChart/PoloniaGeoChart";
import { HolandaChart } from "./charts/GeoChart/HolandaGeoChart";
import { AlemaniaChart } from "./charts/GeoChart/AlemaniaGeoChart";
import { UkChart } from "./charts/GeoChart/UkGeoChart";
import { IndiaChart } from "./charts/GeoChart/IndiaGeoChart";
import { FilipinasChart } from "./charts/GeoChart/FilipinasGeoChart";
import { SueciaChart } from "./charts/GeoChart/SueciaGeoChart";
import { FranciaChart } from "./charts/GeoChart/FranciaGeoChart";
import { NoruegaChart } from "./charts/GeoChart/NoruegaGeoChart";
import { ChinaChart } from "./charts/GeoChart/ChinaGeoChart";
import { DinamarcaChart } from "./charts/GeoChart/DinamarcaGeoChart";
import { GeneroChart } from "./charts/SpecialChart/GeneroChart";
import { BarrasEstadoStack } from "./charts/SpecialChart/BarrasEstadoStackChart";
import { DistibutionStateSeverity } from "./charts/SpecialChart/DistributionStateSeverity";
import { DistibutionStateType } from "./charts/SpecialChart/DistributionStateType";
// import BarChart from "./charts/BarChart/BarChart";
import ParetoChart from "./charts/BarChart/ParetoChart";
import BarChartHorizontal from "./charts/BarChart/BarChartHorizontal";
import { LineOpenCloseChart } from "./charts/SpecialChart/LineOpenCloseChart";
import { InnovaDistribution } from "./charts/SpecialChart/InnovaCharts/innovaDistribution";
import { InnovaDistributionCDMX } from "./charts/SpecialChart/InnovaCharts/InnovaDistributionCDMX";
import { InnovaDonutChart } from "./charts/SpecialChart/InnovaCharts/InnovaDonutChart";
import { InnovaMexicoGeoChart } from "./charts/SpecialChart/InnovaCharts/InnovaMexicoGeoChart";
import { InnovaZonaMexicoChart } from "./charts/SpecialChart/InnovaCharts/InnovaZonaMexicoChart";
import { InnovaBarrasEstadoStack } from "./charts/SpecialChart/InnovaCharts/InnovaBarrasEstadoStackChart";
import { InnovaMultiVerticalBars } from "./charts/SpecialChart/InnovaCharts/InnovaMultiVerticalBars";
import { InnovaSpecificMultiVerticalBars } from "./charts/SpecialChart/InnovaCharts/InnovaSpecificMultiVerticalBars";

import Icon from "../../Icon/Icon";

import { useSnackbar } from "notistack";
import { LoadingGraphic } from "../../Loading/Graphic/Graphic";
import { useTranslation } from "react-i18next";

import { Loading } from "../../Loading/String/Loading";
import _ from "lodash";

export const Graphics = ({ graphicsData, stateLoading = null, order = {} }) => {
  
  const [t] = useTranslation("dashboard");
  const { gTheme } = useSelector((state) => state.theme);
  const theme = gTheme === "dark" ? "dark" : "light";
  const { enqueueSnackbar } = useSnackbar();

  const [graphics, setGraphics] = useState([]);
  const [deleting, setDeleting] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPath, setCurrentPath] = useState(null);

  const [elementVisibility, setElementVisibility] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [customRange, setCustomRange] = useState(false);
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  const [isLoadingMain, setIsLoadingMain] = useState(true);

  const [currentIndexSelected, setCurrentIndexSelected] = useState(null);
  const [currentPathSelected, setCurrentPathSelected] = useState(null);
  const [currentDateSelected, setCurrentDateSelected] = useState({});

  const [currentGraphicIndex, setCurrentGraphicIndex] = useState(null);
  const today = new Date(); // Fecha actual

  const [Graphicsorder, setGraphicsOrder] = useState(order || {}); // Estado local para manejar `order`

  const [selectedDaysPreview, setSelectedDaysPreview] = useState({});

  const [elementVisibilityIndicators, setElementVisibilityIndicators] = useState([]);

  // AbortController para cancelar peticiones anteriores y evitar race conditions
  const abortControllerRef = useRef(null);

  useEffect(() => {
    // Cancelar peticiones anteriores si graphicsData cambia rápido
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setIsLoadingMain(true);

    const days = getDaysSelected();
    setSelectedDaysPreview(days);

    getAllGraphicData(graphicsData, days, controller.signal)
    .then((resp) => {
      if (!controller.signal.aborted) {
        setGraphics(resp);
        setIsLoadingMain(false);
      }
    });

    return () => controller.abort();
  },[graphicsData])

  useEffect(() => {
    const graphicsInBrute = Object.values(graphics);
    const updatedGraphics = reorderGraphics(graphicsInBrute, Graphicsorder);
    setGraphics(updatedGraphics); // Actualiza el estado con las gráficas reordenadas
  }, [Graphicsorder]);

  const organizedGraphics = useMemo(() => {
    
    const orderedGraphics = (Graphicsorder && Object.keys(Graphicsorder).length > 0
      ? Object.keys(Graphicsorder)
        .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
        .map(orderKey => {
          const graphicId = Graphicsorder[orderKey];
          const graphic = graphics.find(graphic => {
            if (graphic == null) return false;
            const pathId = graphic.path.split("::")[1];
            return pathId === graphicId;
          });
          if (graphic) {
            graphic.ordered = true;
          }
          return graphic;
        })
        .filter(graphicItem => !!graphicItem)
      : []
    );

    const unorderedGraphics = graphics.filter(graphic => {
      if (graphic == null) return false;
      const pathId = graphic.path.split("::")[1];
      const isOrdered = Object.values(Graphicsorder || {}).includes(pathId);
      if (!isOrdered) {
        graphic.ordered = false;
      }
      return !isOrdered;
    });

    const combinedGraphics = [...orderedGraphics, ...unorderedGraphics].map((graphic, index) => ({ ...graphic, index }));

    return combinedGraphics.reduce((rows, graphicItem) => {
      const columnLimit = 2;
      const itemColumns = graphicItem.addTwoColumns ? 2 : 1;

      let currentRow = rows[rows.length - 1];

      if (!currentRow || currentRow.totalColumns + itemColumns > columnLimit) {
        currentRow = { totalColumns: 0, items: [] };
        rows.push(currentRow);
      }

      currentRow.items.push(graphicItem);
      currentRow.totalColumns += itemColumns;

      return rows;
    }, []).map(row => row.items);
  }, [graphics]);

  const getDaysSelected = () => {
    setIsLoadingMain(true);
    const newSelectedDays = {};

    if (graphicsData) {
      Object.entries(graphicsData).forEach(([key, value]) => {
        if (value?.r_start && value?.r_end) {
          const startDate = new Date(value.r_start);
          const endDate = new Date(value.r_end);
          const diffDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));

          let calculatedDays = 30;
          if (diffDays <= 30) calculatedDays = 30;
          else if (diffDays <= 60) calculatedDays = 60;
          else if (diffDays <= 90) calculatedDays = 90;
          else if (diffDays <= 183) calculatedDays = 183;
          else if (diffDays <= 365) calculatedDays = 365;

          newSelectedDays[value.path] = calculatedDays;
        } else {
          newSelectedDays[value.path] = 30;
        }
      });
      return newSelectedDays
    }
    setIsLoadingMain(false);
  }

  // Obtener todas las graficas al inicio del componente
  const getAllGraphicData = async (graphs, days, signal) => {
    const chartsPromises = [];
    Object.values(graphs).forEach((value) => {
      const today = new Date();
      const r_end = today.toISOString().split("T")[0]; // Fecha de hoy en formato 'YYYY-MM-DD'
      const r_start = new Date(today.setDate(today.getDate() - days[value.path])).toISOString().split("T")[0]; // Restar el número de días de 'days' a la fecha actual
      chartsPromises.push(getSignleGraphicData(value.path, { r_start, r_end }, signal));
    });
    try {
      const charts = await Promise.allSettled(chartsPromises);
      const failedPromises = [];
      let newCharts = charts.filter((chart, idx) => {
        if (chart.status === "rejected") {
          failedPromises.push(idx);
          return false;
        } else {
          return true;
        }
      });
      newCharts = newCharts.map(item => item.value);
      if (failedPromises.length === 0) {
        enqueueSnackbar(t("Graphics.obtained_data"), {
          variant: "success",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        });
      } else if (failedPromises.length === charts.length) {
        enqueueSnackbar(t("Graphics.load_error"), {
          variant: "error",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        });
      } else if (failedPromises.length > 0) {
        enqueueSnackbar(t("Graphics.partial_error"), {
          variant: "warning",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        });
      }
      return newCharts;
    } catch (error) {
      console.log(error);
    }
  }

  // Obtener fechas de las graficas
  const getSignleGraphicData = async (graphicPath, recivedDays, signal) => {
    const requestData = { path: graphicPath, ...recivedDays };
    try {
      const response = await updateDataGraphicByPath(requestData, signal);
      return response.data;
    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') return null; // Petición cancelada, ignorar
      throw new Error("error")
    }
  };

  // Actualizar fechas de las graficas
  const updateSignleGraphicData = async (graphicPath, days) => {
    // Cancelar petición anterior si el usuario cambia fechas rápidamente
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setCurrentPath(graphicPath);
    setIsLoading(true);

    let requestData;
    if (isNaN(days)) {
      requestData = { path: graphicPath, r_start: days.r_start, r_end: days.r_end };
    } else {
      const today = new Date();
      const r_end = today.toISOString().split("T")[0]; // Fecha de hoy en formato 'YYYY-MM-DD'
      const r_start = new Date(today.setDate(today.getDate() - days)).toISOString().split("T")[0]; // Restar el número de días de 'days' a la fecha actual
      requestData = { path: graphicPath, r_start, r_end };
    }

    try {
      const response = await updateDataGraphicByPath(requestData, controller.signal);
      if (controller.signal.aborted) return null;
      setCurrentPath(null);
      setIsLoading(false);
      return response.data;
    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') return null;
      console.log(error);
      setCurrentPath(null);
      setIsLoading(false);
    }
  };

  // Borrar una grafica
  const deleteGraphic = async (graphicPath) => {
    setDeleting(graphicPath);

    const response = await deleteElement({ path: graphicPath });
    if (stateLoading !== null && response !== undefined) stateLoading(true);
  };

  const toggleElementVisibility = (index) => {
    const updatedElementVisibility = [...elementVisibility];
    updatedElementVisibility[index] = !updatedElementVisibility[index];
    setElementVisibility(updatedElementVisibility);
  };

  const toggleElementVisibilityIndicator = (index) => {
    const updatedElementVisibilityIndicators = [...elementVisibilityIndicators];
    updatedElementVisibilityIndicators[index] = !updatedElementVisibilityIndicators[index];
    setElementVisibilityIndicators(updatedElementVisibilityIndicators);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // Resetear las fechas temporales al cerrar el pop-up
    setCustomRange(false);
    setTempStartDate(null);
    setTempEndDate(null);
  };

  const handleShow = (graphicItem) => {
    const path = graphicItem?.path;
    const idxInGraphicsState = graphics.findIndex(item => item.path === path)
    setCurrentGraphicIndex(idxInGraphicsState);
    setFullscreen(true);
    setShow(true);
  }

  const oneColumn = async (path) => {
    const response = await oneColumnChange({ path: path, addTwoColumns: false });
    if (response.status === 204) {
      enqueueSnackbar(t("Graphics.no_data"), {
        variant: "warning",
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
      });
    }
    if (response.status === 404) {
      enqueueSnackbar(response.data, {
        variant: "error",
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
      });
    }
    window.location.reload();
  }

  const twoColumn = async (path) => {
    const response = await oneColumnChange({ path: path, addTwoColumns: true });
    if (response.status === 204) {
      enqueueSnackbar(t("Graphics.no_data"), {
        variant: "warning",
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
      });
    }
    if (response.status === 404) {
      enqueueSnackbar(response.data, {
        variant: "error",
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
      });
    }
    window.location.reload(); 
  }

  const reorderGraphics = (graphics, Graphicsorder) => {
    if (!Graphicsorder || Object.keys(Graphicsorder).length === 0) {
      return graphics; // Si no hay orden definido, no modificamos nada
    }

    const orderedGraphics = Object.keys(Graphicsorder)
      .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
      .map(orderKey => {
        const graphicId = Graphicsorder[orderKey];
        const graphic = graphics.find(graphic => {
          const pathId = graphic.path.split("::")[1];
          return pathId === graphicId;
        });
        if (graphic) {
          graphic.ordered = true;
        }
        return graphic;
      })
      .filter(graphicItem => !!graphicItem); // Filtrar elementos válidos

    const unorderedGraphics = graphics.filter(graphic => {
      const pathId = graphic.path.split("::")[1];
      const isOrdered = Object.values(Graphicsorder).includes(pathId);
      if (!isOrdered) {
        graphic.ordered = false;
      }
      return !isOrdered;
    });

    return [...orderedGraphics, ...unorderedGraphics];
  };

  const modifyOrderUp = async(path) => {

    const graphicId = path.split("::")[1];
    const currentIndex = Object.keys(Graphicsorder).find(key => Graphicsorder[key] === graphicId);

    if (currentIndex && parseInt(currentIndex, 10) > 1) {
      const prevIndex = parseInt(currentIndex, 10) - 1;

      const newOrder = { ...Graphicsorder };
      [newOrder[prevIndex], newOrder[currentIndex]] = [newOrder[currentIndex], newOrder[prevIndex]];

      try {
        await modifyOrder({ path: path, direction: 'up' })
        setGraphicsOrder(newOrder);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const modifyOrderDown = async(path) => {
    const graphicId = path.split("::")[1];
    const currentIndex = Object.keys(Graphicsorder).find(key => Graphicsorder[key] === graphicId);

    if (currentIndex && parseInt(currentIndex, 10) < Object.keys(Graphicsorder).length) {
      const nextIndex = parseInt(currentIndex, 10) + 1;

      const newOrder = { ...Graphicsorder };
      [newOrder[nextIndex], newOrder[currentIndex]] = [newOrder[currentIndex], newOrder[nextIndex]];

      try {
        await modifyOrder({ path: path, direction: 'down' })
        setGraphicsOrder(newOrder);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const activateOrder = async(path) => {
    const graphicId = path.split("::")[1];

    const isAlreadyOrdered = Object.values(Graphicsorder).includes(graphicId);

    if (!isAlreadyOrdered) {
      const newOrder = { ...Graphicsorder };

      const newIndex = Object.keys(newOrder).length + 1;
      newOrder[newIndex] = graphicId;

      try {
        await modifyOrder({ path: path, direction: 'addIndice' });
        setGraphicsOrder(newOrder);
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Cambia el rango de fechas de la grafica a uno establecido
  const handleSelectDateChange = async(e, graphicPath) => {
    const selectedValue = e.target.value;
    setCurrentIndexSelected(/*((rowIndex * 2) + index)*/e.target.value);
    setCurrentPathSelected(graphicPath);
    setSelectedDaysPreview({
      ...selectedDaysPreview,
      [graphicPath]: selectedValue, // Usamos graphicItem.path como la clave para el valor seleccionado
    });
    
    if (selectedValue === 'custom') {
      setCustomRange(true);
      handleClick(e);
    } else {
      setCustomRange(false); // Ocultar el calendario
      const resp = await updateSignleGraphicData(graphicPath, selectedValue);
      if (!resp) return; // Petición cancelada
      setGraphics(prev => {
        const indexChange = prev.findIndex(item => item.path === resp.path);
        const newGraphics = _.cloneDeep(prev);
        newGraphics[indexChange] = resp;
        return newGraphics
      })
    }
  }

  // Cambia el rango de fechas de la grafica a uno personalizado
  const handleCustomDate = async() => {
    if (!tempStartDate || !tempEndDate) return;
    const formattedStartDate = format(tempStartDate, 'yyyy-MM-dd');
    const formattedEndDate = format(tempEndDate, 'yyyy-MM-dd');
    const visibleStartDate = format(tempStartDate, 'dd-MM-yyyy');
    const visibleEndDate = format(tempEndDate, 'dd-MM-yyyy');
    setCurrentDateSelected(prevState => ({
      ...prevState,
      [currentIndexSelected]: `${visibleStartDate} - ${visibleEndDate}`
    }));
    const resp = await updateSignleGraphicData(currentPathSelected, { r_start: formattedStartDate, r_end: formattedEndDate });
    if (!resp) return; // Petición cancelada
    setGraphics(prev => {
      const indexChange = prev.findIndex(item => item.path === resp.path);
      const newGraphics = _.cloneDeep(prev);
      newGraphics[indexChange] = resp;
      return newGraphics
    })
    handleClose();
  }

  const open = Boolean(anchorEl);
  const id = open ? 'date-popover' : undefined;

  return (
    <>
    {!isLoadingMain ? (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {organizedGraphics.map((rowGraphics, rowIndex) => (
        <Row key={rowIndex} className="graphic-row">
          {rowGraphics.map((graphicItem, index) => (

            <Col
              key={((rowIndex * 2) + index)}
              sm={graphicItem.addTwoColumns ? 12 : 6}
              md={graphicItem.addTwoColumns ? 12 : 6}
              lg={graphicItem.addTwoColumns ? 12 : 6}
              className={`graphic-content ${theme} `}
            >
              <div className={`graphic-header ${theme} ${elementVisibilityIndicators[((rowIndex * 2) + index)] ? 'col-lg-8' : 'col-lg-12'}`}>
                <Col className="subtitle" lg={8}>
                  {graphicItem.title === deleting
                    ? `${t("Graphics.deleting")}...`
                    : graphicItem.title}
                </Col>

                <Col lg={4} className={`options ${theme}`}>
                  <Col sm={10}>

                    <MCTooltip text={t("Graphics.get_results")} position="bottom">

                      <Form.Select
                        size="sm"
                        value={selectedDaysPreview?.[graphicItem?.path] || "custom"} // Aquí se usa graphicItem.path como clave
                        onChange={(e) => handleSelectDateChange(e, graphicItem.path)}
                      >
                        <option value={30}>{t("Graphics.last_30")}</option>
                        <option value={60}>{t("Graphics.last_60")}</option>
                        <option value={90}>{t("Graphics.last_90")}</option>
                        <option value={183}>{t("Graphics.past_six_months")}</option>
                        <option value={365}>{t("Graphics.last_year")}</option>
                        <option value="custom">{currentDateSelected[((rowIndex * 2) + index)] || t("Graphics.custom_range")}</option>
                      </Form.Select>
                    </MCTooltip>

                  </Col>


                  {graphicItem.ordered == true ? (
                    <>
                      <EGIconButton
                        iconSize={16}
                        className="graphic-option"
                        iconName="arrow_up_4"
                        onClick={() => modifyOrderUp(graphicItem.path)}
                        title={t("Graphics.move_up")}
                      />
                      <EGIconButton
                        iconSize={16}
                        className="graphic-option"
                        iconName="arrow_down"
                        onClick={() => modifyOrderDown(graphicItem.path)}
                        title={t("Graphics.move_down")}
                      />
                    </>
                  ) : (
                    <>
                      <EGIconButton
                        iconSize={16}
                        className="graphic-option"
                        iconName="arrow_swap"
                        onClick={() => {
                          activateOrder(graphicItem.path);
                        }}
                        title={t("Graphics.activate_order")}
                      />
                    </>
                  )
                  }

                  {customRange && (
                    <Popover
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                    >
                      <Box sx={{ p: 2 }}>
                        <DatePicker
                          label={t("Graphics.start_date")}
                          value={tempStartDate}
                          onChange={(newValue) => setTempStartDate(newValue)}
                          maxDate={today}
                          textField={(params) => <TextField {...params} />}
                        />
                        <Box sx={{ my: 2 }} />
                        <DatePicker
                          label={t("Graphics.end_date")}
                          value={tempEndDate}
                          onChange={(newValue) => setTempEndDate(newValue)}
                          minDate={tempStartDate}
                          maxDate={today}
                          textField={(params) => <TextField {...params} />}
                        />
                        <EGButton
                          label={t("Graphics.apply_custom_range")}
                          color="primary"
                          sx={{
                            display: 'flex', justifyContent: 'flex-end', mt: 2

                          }} 
                          onClick={handleCustomDate}

                          disabled={!tempStartDate || !tempEndDate || tempEndDate < tempStartDate}
                        />

                      </Box>
                    </Popover>
                  )}

                  <button
                    onClick={() => handleShow(graphicItem)}
                    className="maximize-button"
                  >
                    <Icon
                      size={20}
                      name="outline_maximize"
                    />
                  </button>
                  <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
                    <Modal.Header closeButton>
                      <Modal.Title>{graphics[currentGraphicIndex]?.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {graphics[currentGraphicIndex] && (
                        <div className="graphic-element">
                          {graphics[currentGraphicIndex].show_graphic === "bars" ? (
                            <>
                              {graphics[currentGraphicIndex].show_graphic_graphic == 3 ? (
                                <BarChartHorizontal chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 4 ? (
                                <BarChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 5 ? (
                                <ParetoChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : (
                                <BarChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              )}
                            </>
                          ) : graphics[currentGraphicIndex].show_graphic === "circles" ? (
                            <>
                              {graphics[currentGraphicIndex].show_graphic_graphic == 1 ? (
                                <PieChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 2 ? (
                                <DonutChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 8 ? (
                                <DoubleChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 47 ? (
                                <NightingaleChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 48 ? (
                                <RoseChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : (
                                <PieChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              )}
                            </>

                          ) : graphics[currentGraphicIndex].show_graphic === "historic" ? (
                            <>
                              {graphics[currentGraphicIndex].show_graphic_graphic == 6 ? (
                                <LineChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 7 ? (
                                <LineChartWhitOutScales chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 9 ? (
                                <LineChartSteps chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 11 ? (
                                <BarChartHistoric chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 23 ? (
                                <MonthsReportsHistoric chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 100 ? (
                                <MonthsReportsHistoricBarChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : (
                                <PieChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              )}
                            </>
                          ) : graphics[currentGraphicIndex].show_graphic === "radar" ? (
                            <>
                              {graphics[currentGraphicIndex].show_graphic_graphic == 10 ? (
                                <RadarChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : (
                                <PieChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              )}
                            </>
                          ) : graphics[currentGraphicIndex].show_graphic === "special" ? (
                            <>
                              {graphics[currentGraphicIndex].show_graphic_graphic == 14 ? (
                                <BarChartHorizontal chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 15 ? (
                                <LineOpenCloseChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 16 ? (
                                <GeoXTypeChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 17 ? (
                                <LineDoubleOpenClose chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 18 ? (
                                <DispersionChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 19 ? (
                                <BarrasEstadoStack chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 20 ? (
                                <GeneroChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 21 ? (
                                <DistibutionStateSeverity chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 22 ? (
                                <DistibutionStateType chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 23 ? (
                                <InnovaDistribution chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 24 ? (
                                <InnovaDistribution chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 25 ? (
                                <InnovaDistribution chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 26 ? (
                                <InnovaDistribution chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 27 ? (
                                <InnovaDistribution chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 28 ? (
                                <InnovaDonutChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 29 ? (
                                <InnovaDonutChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 30 ? (
                                <InnovaDonutChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 31 ? (
                                <InnovaDonutChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 32 ? (
                                <InnovaDonutChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 33 ? (
                                <InnovaMexicoGeoChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 34 ? (
                                <InnovaMexicoGeoChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 35 ? (
                                <InnovaMexicoGeoChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 36 ? (
                                <InnovaMexicoGeoChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 37 ? (
                                <InnovaMexicoGeoChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 38 ? (
                                <InnovaBarrasEstadoStack chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 39 ? (
                                <InnovaBarrasEstadoStack chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 40 ? (
                                <InnovaBarrasEstadoStack chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 41 ? (
                                <InnovaBarrasEstadoStack chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 42 ? (
                                <InnovaBarrasEstadoStack chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 43 ? (
                                <InnovaMultiVerticalBars chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 44 ? (
                                <InnovaSpecificMultiVerticalBars chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 45 ? (
                                <InnovaZonaMexicoChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 46 ? (
                                <InnovaDistributionCDMX chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : (
                                <PieChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              )}
                            </>
                          ) : graphics[currentGraphicIndex].show_graphic === "geographic" ? (
                            <>
                              {graphics[currentGraphicIndex].show_graphic_graphic == 12 ? (
                                <WorldBubbleChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 13 ? (
                                <MexicoChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 120 ? (
                                <ColombiaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 121 ? (
                                <HondurasChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 122 ? (
                                <ElSalvadorChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 123 ? (
                                <ChileChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 124 ? (
                                <EcuadorChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 125 ? (
                                <GuatemalaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 126 ? (
                                <PeruChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 127 ? (
                                <NicaraguaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 128 ? (
                                <PanamaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 129 ? (
                                <USAChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 130 ? (
                                <CanadaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 131 ? (
                                <BrasilChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 132 ? (
                                <EspanaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 133 ? (
                                <ItalyChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 134 ? (
                                <PortugalChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 135 ? (
                                <PoloniaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 136 ? (
                                <HolandaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 137 ? (
                                <AlemaniaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 138 ? (
                                <UkChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 139 ? (
                                <IndiaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 140 ? (
                                <FilipinasChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 141 ? (
                                <SueciaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 142 ? (
                                <FranciaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 143 ? (
                                <NoruegaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 144 ? (
                                <ChinaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : graphics[currentGraphicIndex].show_graphic_graphic == 145 ? (
                                <DinamarcaChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              ) : (
                                <PieChart chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                              )}
                            </>
                          ) : (
                            <>
                              {/* Antes: <LineChartWhitOutScales chartData={graphics[currentGraphicIndex]} maximize={true} /> */}
                              <LineChartWhitOutScales chartData={graphics[currentGraphicIndex]} startDate={startDate} endDate={endDate} maximize={true} />
                            </>
                          )}
                        </div>
                      )}
                    </Modal.Body>
                  </Modal>

                  <Col sm={2} className={`option-menu ${theme} `}>
                    <div className={`graphic-options ${theme}`}>
                      <MCTooltip text={t("Graphics.options")} position="bottom">
                        <DropdownButton
                          key="end"
                          id="dropdown-button-drop-end"
                          drop="end"
                          title="ooo"
                        >
                          {/* <Dropdown.Item eventKey="1">
                                {t("dashboard.graphics.dropdown.changeRange")}
                              </Dropdown.Item>
                              <Dropdown.Item eventKey="2">
                                {t("dashboard.graphics.dropdown.asignRangue")}
                              </Dropdown.Item>
                              <Dropdown.Divider /> */}
                          <Dropdown.Item
                            eventKey="4"
                            onClick={() => deleteGraphic(graphicItem.path)}
                          >
                            {t("Graphics.delete")}
                          </Dropdown.Item>
                          {graphicItem.addTwoColumns ? (
                            <Dropdown.Item
                              eventKey="4"
                              onClick={() => oneColumn(graphicItem.path)}
                            >
                              {t("Graphics.add_one_column")}
                            </Dropdown.Item>
                          ) : (
                            <Dropdown.Item
                              eventKey="4"
                              onClick={() => twoColumn(graphicItem.path)}
                            >
                              {t("Graphics.add_two_column")}
                            </Dropdown.Item>
                          )}
                        </DropdownButton>
                      </MCTooltip>
                    </div>
                  </Col>
                </Col>
              </div>

              {Object.keys(graphicItem.indicators).length > 0 ? (
                <div className="row">
                  <div className="col-12">
                    <div
                      // Anterior: currentGraphicIndex === graphicItem.path (comparaba índice numérico con string path)
                      className={`graphic-container ${isLoading && currentPath === graphicItem.path ? "show-loading" : ""
                        }`}
                    >
                      <LoadingGraphic />
                      <Row className="graphic-body">
                        {graphicItem.show_graphic_graphic !== "19" && graphicItem.show_graphic_graphic !== "16" && graphicItem.show_graphic_graphic !== "22" ? (
                          <Col lg={elementVisibilityIndicators[index] ? 8 : 12}>
                            <div className="graphic-switch ">
                              <Icon
                                size={16}
                                className="graphic-option"
                                name="bar_chart_bold"
                              />
                              <FormCheck
                                type="switch"
                                checked={elementVisibilityIndicators[graphicItem.index]}
                                onChange={() => toggleElementVisibilityIndicator(graphicItem.index)}
                              />
                              <Icon
                                size={16}
                                className="data-option"
                                name="outline_chart_bold"
                              />
                            </div>
                          </Col>
                        ) :
                          (
                            <></>
                          )}
                        {elementVisibility[graphicItem.index] ? (
                          <div className="graphic-indicators">
                            <GraphicComplements chartData={graphicItem} startDate={startDate} endDate={endDate} />
                          </div>
                        ) : (
                          <Col lg={elementVisibilityIndicators[graphicItem.index] ? 8 : 12} className="graphic-element">
                            {graphicItem.show_graphic === "bars" ? (
                              <>
                                {graphicItem.show_graphic_graphic == 3 ? (
                                  <BarChartHorizontal chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 4 ? (
                                  <BarChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 5 ? (
                                  <ParetoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : (
                                  <BarChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                )}
                              </>
                            ) : graphicItem.show_graphic === "circles" ? (
                              <>
                                {graphicItem.show_graphic_graphic == 1 ? (
                                  <PieChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 2 ? (
                                  <DonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 8 ? (
                                  <DoubleChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 47 ? (
                                  <NightingaleChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 48 ? (
                                  <RoseChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : (
                                  <DonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                )}
                              </>
                            ) : graphicItem.show_graphic === "historic" ? (
                              <>
                                {graphicItem.show_graphic_graphic == 6 ? (
                                  <LineChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 7 ? (
                                  <LineChartWhitOutScales chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 9 ? (
                                  <LineChartSteps chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 11 ? (
                                  <BarChartHistoric chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 23 ? (
                                  <MonthsReportsHistoric chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 100 ? (
                                  <MonthsReportsHistoric chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : (
                                  <PieChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                )}
                              </>
                            ) : graphicItem.show_graphic === "radar" ? (
                              <>
                                {graphicItem.show_graphic_graphic == 10 ? (
                                  <RadarChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : (
                                  <PieChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                )}
                              </>
                            ) : graphicItem.show_graphic === "special" ? (
                              <>
                                {graphicItem.show_graphic_graphic == 14 ? (
                                  <BarChartHorizontal chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 15 ? (
                                  <LineOpenCloseChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 16 ? (
                                  <GeoXTypeChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 17 ? (
                                  <LineDoubleOpenClose chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 18 ? (
                                  <DispersionChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 19 ? (
                                  <BarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 20 ? (
                                  <GeneroChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 21 ? (
                                  <DistibutionStateSeverity chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 22 ? (
                                  <DistibutionStateType chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 100 ? (
                                  <MonthsReportsHistoricBarChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 23 ? (
                                  <InnovaDistribution chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 24 ? (
                                  <InnovaDistribution chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 25 ? (
                                  <InnovaDistribution chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 26 ? (
                                  <InnovaDistribution chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 27 ? (
                                  <InnovaDistribution chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 28 ? (
                                  <InnovaDonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 29 ? (
                                  <InnovaDonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 30 ? (
                                  <InnovaDonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 31 ? (
                                  <InnovaDonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 32 ? (
                                  <InnovaDonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 33 ? (
                                  <InnovaMexicoGeoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 34 ? (
                                  <InnovaMexicoGeoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 35 ? (
                                  <InnovaMexicoGeoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 36 ? (
                                  <InnovaMexicoGeoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 37 ? (
                                  <InnovaMexicoGeoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 38 ? (
                                  <InnovaBarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 39 ? (
                                  <InnovaBarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 40 ? (
                                  <InnovaBarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 41 ? (
                                  <InnovaBarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 42 ? (
                                  <InnovaBarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 43 ? (
                                  <InnovaMultiVerticalBars chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 44 ? (
                                  <InnovaSpecificMultiVerticalBars chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 45 ? (
                                  <InnovaZonaMexicoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                ) : graphicItem.show_graphic_graphic == 46 ? (
                                  <InnovaDistributionCDMX chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />

                                ) : (
                                  <PieChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                                )}
                              </>
                            ) : graphicItem.show_graphic === "geographic" ? (
                              <>
                                {graphicItem.show_graphic_graphic == 12 ? (
                                  <WorldBubbleChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 13 ? (
                                  <MexicoChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 120 ? (
                                  <ColombiaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 121 ? (
                                  <HondurasChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 122 ? (
                                  <ElSalvadorChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 123 ? (
                                  <ChileChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 124 ? (
                                  <EcuadorChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 125 ? (
                                  <GuatemalaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 126 ? (
                                  <PeruChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 127 ? (
                                  <NicaraguaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 128 ? (
                                  <PanamaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 129 ? (
                                  <USAChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 130 ? (
                                  <CanadaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 131 ? (
                                  <BrasilChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 132 ? (
                                  <EspanaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 133 ? (
                                  <ItalyChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 134 ? (
                                  <PortugalChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 135 ? (
                                  <PoloniaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 136 ? (
                                  <HolandaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 137 ? (
                                  <AlemaniaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 138 ? (
                                  <UkChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 139 ? (
                                  <IndiaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 140 ? (
                                  <FilipinasChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 141 ? (
                                  <SueciaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 142 ? (
                                  <FranciaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 143 ? (
                                  <NoruegaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 144 ? (
                                  <ChinaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : graphicItem.show_graphic_graphic == 145 ? (
                                  <DinamarcaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                ) : (
                                  <PieChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                                )}
                              </>
                            ) : (
                              <>
                                {/* Antes: <LineChartWhitOutScales chartData={graphicItem} /> */}
                                <LineChartWhitOutScales chartData={graphicItem} startDate={startDate} endDate={endDate} />
                              </>
                            )}
                          </Col>
                        )}
                        {elementVisibilityIndicators[index] ? (
                          <Col lg={4}>
                            <div className="graphic-indicators-right" > 
                              <GraphicComplements chartData={graphicItem} startDate={startDate} endDate={endDate} right={true} />
                            </div>
                          </Col>
                        ) : (
                          <></>
                        )}
                      </Row>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={`graphic-container ${isLoading && (currentPath === graphicItem.path) ? "show-loading" : ""
                    }`}
                >
                  <LoadingGraphic />
                  <Row className="graphic-body">
                    {graphicItem.show_graphic_graphic !== "19" && graphicItem.show_graphic_graphic !== "16" && graphicItem.show_graphic_graphic !== "22" ? (
                      <div className="graphic-switch">
                        <Icon
                          size={16}
                          className="graphic-option"
                          name="bar_chart_bold"
                        />
                        <FormCheck
                          type="switch"
                          checked={elementVisibility[graphicItem.index]}
                          onChange={() => toggleElementVisibility(graphicItem.index)}
                        />
                        <Icon
                          size={16}
                          className="data-option"
                          name="outline_chart_bold"
                        />
                      </div>
                    ) :
                      (
                        <></>
                      )}
                    {elementVisibility[graphicItem.index] ? (
                      <div className="graphic-indicators">
                        <GraphicComplements chartData={graphicItem} startDate={startDate} endDate={endDate} />
                      </div>
                    ) : (
                      <Col lg={12} className="graphic-element">
                          
                          {
                            graphicItem?.data?.some(item => item?.data?.some(arr => arr?.length > 0)) === false && (
                              <Col sm={12} className="d-flex justify-content-center align-items-center">
                                <div className={`indicator-body ${theme}`}>
                                  {t("indicators.empty")}
                                </div>
                              </Col>
                            )
                          }
                        {graphicItem.show_graphic === "bars" ? (
                          <>
                            {graphicItem.show_graphic_graphic == 3 ? (
                              <BarChartHorizontal chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 4 ? (
                              <BarChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 5 ? (
                              <ParetoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : (
                              <BarChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            )}
                          </>
                        ) : graphicItem.show_graphic === "circles" ? (
                          <>
                            {graphicItem.show_graphic_graphic == 1 ? (
                              <PieChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 2 ? (
                              <DonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 8 ? (
                              <DoubleChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 47 ? (
                              <NightingaleChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 48 ? (
                              <RoseChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : (
                              <DonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            )}
                          </>
                        ) : graphicItem.show_graphic === "historic" ? (
                          <>
                            {graphicItem.show_graphic_graphic == 6 ? (
                              <LineChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 7 ? (
                              <LineChartWhitOutScales chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 9 ? (
                              <LineChartSteps chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 11 ? (
                              <BarChartHistoric chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 23 ? (
                              <MonthsReportsHistoric chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 100 ? (
                              <MonthsReportsHistoricBarChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : (
                              <PieChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            )}
                          </>
                        ) : graphicItem.show_graphic === "radar" ? (
                          <>
                            {graphicItem.show_graphic_graphic == 10 ? (
                              <RadarChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : (
                              <PieChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            )}
                          </>
                        ) : graphicItem.show_graphic === "special" ? (
                          <>
                            {graphicItem.show_graphic_graphic == 14 ? (
                              <BarChartHorizontal chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 15 ? (
                              <LineOpenCloseChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 16 ? (
                              <GeoXTypeChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 17 ? (
                              <LineDoubleOpenClose chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 18 ? (
                              <DispersionChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 19 ? (
                              <BarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 20 ? (
                              <GeneroChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 21 ? (
                              <DistibutionStateSeverity chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 22 ? (
                              <DistibutionStateType chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 23 ? (
                              <InnovaDistribution chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 24 ? (
                              <InnovaDistribution chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 25 ? (
                              <InnovaDistribution chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 26 ? (
                              <InnovaDistribution chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 27 ? (
                              <InnovaDistribution chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 28 ? (
                              <InnovaDonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 29 ? (
                              <InnovaDonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 30 ? (
                              <InnovaDonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 31 ? (
                              <InnovaDonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 32 ? (
                              <InnovaDonutChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 33 ? (
                              <InnovaMexicoGeoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 34 ? (
                              <InnovaMexicoGeoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 35 ? (
                              <InnovaMexicoGeoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 36 ? (
                              <InnovaMexicoGeoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 37 ? (
                              <InnovaMexicoGeoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 38 ? (
                              <InnovaBarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 39 ? (
                              <InnovaBarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 40 ? (
                              <InnovaBarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 41 ? (
                              <InnovaBarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 42 ? (
                              <InnovaBarrasEstadoStack chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 43 ? (
                              <InnovaMultiVerticalBars chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 44 ? (
                              <InnovaSpecificMultiVerticalBars chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 45 ? (
                              <InnovaZonaMexicoChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : graphicItem.show_graphic_graphic == 46 ? (
                              <InnovaDistributionCDMX chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            ) : (
                              <PieChart chartData={graphicItem} startDate={startDate} endDate={endDate} maximize={false} />
                            )}
                          </>
                        ) : graphicItem.show_graphic === "geographic" ? (
                          <>
                            {graphicItem.show_graphic_graphic == 12 ? (
                              <WorldBubbleChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 13 ? (
                              <MexicoChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 120 ? (
                              <ColombiaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 121 ? (
                              <HondurasChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 122 ? (
                              <ElSalvadorChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 123 ? (
                              <ChileChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 124 ? (
                              <EcuadorChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 125 ? (
                              <GuatemalaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 126 ? (
                              <PeruChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 127 ? (
                              <NicaraguaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 128 ? (
                              <PanamaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 129 ? (
                              <USAChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 130 ? (
                              <CanadaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 131 ? (
                              <BrasilChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 132 ? (
                              <EspanaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 133 ? (
                              <ItalyChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 134 ? (
                              <PortugalChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 135 ? (
                              <PoloniaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 136 ? (
                              <HolandaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 137 ? (
                              <AlemaniaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 138 ? (
                              <UkChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 139 ? (
                              <IndiaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 140 ? (
                              <FilipinasChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 141 ? (
                              <SueciaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 142 ? (
                              <FranciaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 143 ? (
                              <NoruegaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 144 ? (
                              <ChinaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : graphicItem.show_graphic_graphic == 145 ? (
                              <DinamarcaChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            ) : (
                              <PieChart chartData={graphicItem} startDate={startDate} endDate={endDate} />
                            )}
                          </>
                        ) : (
                          <>
                            {/* Antes: <LineChartWhitOutScales chartData={graphicItem} /> */}
                            <LineChartWhitOutScales chartData={graphicItem} startDate={startDate} endDate={endDate} />
                          </>
                        )}
                      </Col>
                    )}
                  </Row>
                </div>
              )}
            </Col>
          ))}
        </Row>
      ))
      }
    </LocalizationProvider>
    ):(<Loading/>)}
    </>
  );
};